import request from "@/utils/request";

// 获取姓氏列表
export function getSurnameList() {
  return request({
    url: "/hundreds/surname/list",
    method: "get"
  })
}

// 获取家谱库列表
export function getFamilyTreeList(params) {
  return request({
    url: "/family/library/page",
    method: "get",
    params
    // {
    //   isFillImg: 2,  1：填充图片，2：不填充图片
    //   parentId,
    //   pageNum: 1,
    //   pageSize: -1,
    // }
  })
}

// 获取该姓氏全部编委会
export function getFamilyTreeCommitteeList(familyName) {
  return request({
    url: "/family/tree/committee/list",
    method: "get",
    params: {
      familyName,
    }
  })
}

// 获取编委会通知分页列表
export function getCommitteeNoticeList(familyTreeId, pageNum = 1, pageSize = -1) {
  return request({
    url: "/sys/ec/notice/page",
    method: "get",
    params: {
      familyTreeId,
      pageNum: pageNum,
      pageSize: pageSize,
    }
  })
}

//获取家谱文件
export function getFamilyTreeFile(familyTreeId) {
  return request({
    url: `/family/tree/document/${familyTreeId}?visible=1`,
    method: "get"
  })
}

// 获取家族企业列表
export function getFamilyTreeCompanyList(familyTreeId, pageNum = 1, pageSize = -1) {
  return request({
    url: "/sys/ec/enterprise/page",
    method: "get",
    params: {
      familyTreeId,
      pageNum: pageNum,
      pageSize: pageSize,
    }
  })
}

// 获取编委会轮播图
export function getCommitteeCarouselList(familyTreeId) {
  return request({
    url: "/sys/ec/carousel/page",
    method: "get",
    params: {
      familyTreeId,
      pageNum: 1,
      pageSize: -1,
    }
  })
}

// 获取宗亲分布
export function getFamilyTreeDistributionList(familyTreeId) {
  return request({
    url: `family/tree/people/num/statistics/${familyTreeId}`,
    method: "get"
  })
}

//根据姓氏获取编委会
export function getCommitteeListBySurname(familyName) {
  return request({
    url: "/family/tree/committee/list",
    method: "get",
    params: {
      familyName,
    }
  })
}

// 获取编委会相册
export function getCommitteeAlbumList(committeeId) {
  return request({
    url: "/photo/album/page",
    method: "get",
    params: {
      committeeId,
      pageNum: 1,
      pageSize: -1,
    }
  })
}

// 根据app类型获取最新版本信息
export function getLatestVersion(appType) {
  // appType: 1-android端，2-ios端
  return request({
    url: `/app/version/${appType}`,
    method: "get"
  })
}

// 获取整颗家谱树     获取家族成员所有信息
export function getFamilyTree(familyTreeId) {
  return request({
    url: `/family/member/tree`,
    method: "get",
    params: {
      familyTreeId,
    }
  })
}

// 获取编委会管理人员信息
export function getCommitteeManagerList(familyTreeId) {
  return request({
    url: `/family/tree/org/group`,
    method: "get",
    params: {
      familyTreeId,
    }
  })
}

